enum WaybillNoExportExportItem {
    LOGISTIC_COMPANY = "LOGISTIC_COMPANY",
    WAYBILL_NO = "WAYBILL_NO",
    PARENT_WAYBILL_NO = "PARENT_WAYBILL_NO",
    EWAYBILL_BRANCH_INFO = "EWAYBILL_BRANCH_INFO",
    WAYBILL_TEMPLATE_NAME = "WAYBILL_TEMPLATE_NAME",
    POSTAGE = "POSTAGE",
    WEIGHT = "WEIGHT",
    PRINT_TIME = "PRINT_TIME",
    NAME = "NAME",
    MOBILE = "MOBILE",
    TELEPHONE = "TELEPHONE",
    PROVINCE = "PROVINCE",
    CITY = "CITY",
    DISTRICT = "DISTRICT",
    TOWN = "TOWN",
    ZIP_CODE = "ZIP_CODE",
    SHOP_NAME = "SHOP_NAME",
    RETAILER_SHOP_NAME = "RETAILER_SHOP_NAME",
    ORDER_ORIGINAL_ID = "ORDER_ORIGINAL_ID",
    SHIPPING_TIME = "SHIPPING_TIME",
    ORDER_SELLER_REMARK = "ORDER_SELLER_REMARK",
    PRODUCT_TITLE = "PRODUCT_TITLE",
    PRODUCT_EXTERNAL_ID = "PRODUCT_EXTERNAL_ID",
    SKU_EXTERNAL_ID = "SKU_EXTERNAL_ID",
    SKU_PROPERTIES_NAME = "SKU_PROPERTIES_NAME",
    SKU_QUANTITY = "SKU_QUANTITY",
    SKU_WEIGHT = "SKU_WEIGHT",
    ORDER_TIME = "ORDER_TIME",
    BUYER_NICKNAME = "BUYER_NICKNAME",
}

export default WaybillNoExportExportItem;
